import { useFetchClubsRegistrationsQuery } from "../../store/club/ClubApi";
import { useGetProfileQuery } from "../../store/auth/AuthApi";
import { useFetchTeamsQuery, useDeleteTeamMutation } from "../../store/team/TeamApi";
import { myConstants } from "../Constants";
import { Arabic2Roman } from "../Tools";
import { ConfirmDialog } from '../ConfirmDialog';

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Drawer from '@mui/material/Drawer';
import * as React from 'react';
import { Collapse } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useParams, useNavigate } from "react-router";

import GirlIcon from '@mui/icons-material/Girl';
import WomanIcon from '@mui/icons-material/Woman';
import BoyIcon from '@mui/icons-material/Boy';
import ManIcon from '@mui/icons-material/Man';
import GroupIcon from '@mui/icons-material/Group';
import GroupsIcon from '@mui/icons-material/Groups';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import RemoveCircleOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import IconButton from '@mui/material/IconButton';
import TableChartIcon from '@mui/icons-material/TableChart';
import InterestsRoundedIcon from '@mui/icons-material/InterestsRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlined';
import { styled } from '@mui/material/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

export const drawerWidth = 250;

const DrawerHeader = styled('div')(({ theme }) => ({ 
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));


/*
 * Erstellt den Namen eines Teams
*/
function teamName(is_female, is_u8)
{
  return (is_female?'w':'m') + (is_u8?'u8':'u10');
}


function TeamItems({year, localTeams, totalTeamCount, is_female, is_u8, clubLabel, destination, selectedClub})          
{ 

  // Keine Lokalen teams gefunden?... dann springen wir direkt weiter...
  if (!localTeams)
    localTeams = [];

  // die Navigation führen wir hier über navigate durch,
  // damit die Seite nicht immer neu aufgebaut werden muss,
  // wenn irgendwo draufgedrückt wird: 
  const navigate = useNavigate();

  /*
    // Hier ist direktes Löschen möglich und wir nutzen
    // die Team-Delete-Mutatio dafür
    const [deleteTeam] = useDeleteTeamMutation();
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [teamToDelete, setTeamToDelete] = React.useState(null);  
  */

  // Prüfen, wie viele Einträge es derzeit gibt  
  const team_name  = teamName(is_female, is_u8);

  const nextEntry = (totalTeamCount ?? localTeams.length ) + 1;
  const nextEntryName = team_name + ' ' + Arabic2Roman(nextEntry) + ' anmelden';

  /*
    //
    // In diesem Fall wurde das Löschen bestätigt und
    // es beginnt an dieser Stelle direkt
    // 
    const handleDeleteConfirmed = async () =>
    {
      // Löschen des Teams anstoßen
      await deleteTeam({year, clubLabel, teamLabel : teamToDelete.label, teamCounter: teamToDelete.counter});
      // danach einfach alles wiedr zurücksetzen
      setConfirmOpen(false);
      setTeamToDelete(null);
    } 
  */


  return(
    <List component="div" disablePadding>
      {
        localTeams.map( 
          team => 
          (        
            <ListItem 
              variant="level-3"               
              key={year + team.label + String(team.counter)} 
              //secondaryAction={
              //  <IconButton edge="end" aria-label="delete"                   
              //    onClick={ () => 
              //      {
              //        setTeamToDelete(team);
              //        setConfirmOpen(true);
              //      }
              //  }
              //  >
              //   <DeleteIcon />
              //  </IconButton>
              //}
            >
              <ListItemIcon ><GroupIcon /></ListItemIcon>  
              <IconButton onClick={ () => navigate(destination + team.label + '/' + team.counter + '/') }>                                            
                <ListItemText primary={teamName(is_female, is_u8) + ' ' + Arabic2Roman(team.counter)} />
              </IconButton>
            </ListItem>
          )
        )
      }    
      <ListItem variant="level-3" color="secondary" key={year + team_name + "-AddTeam"} disablePadding>
        <ListItemButton onClick=
          {
            async () => 
            {
              navigate(destination + team_name + '/' + nextEntry + '/' + myConstants.endpoints.actions.team.add ) 
            }
          } 
        >
          <ListItemIcon ><AddCircleOutlineIcon /></ListItemIcon>
          <ListItemText primary={nextEntryName} />
        </ListItemButton>
      </ListItem>
      
      {
      //  <ConfirmDialog
      //    open={confirmOpen}
      //    title="Team löschen"
      //    text={teamToDelete ? `${teamName(is_female, is_u8)} ${Arabic2Roman(teamToDelete.counter)} wirklich löschen?` : ''}
      //    onConfirm={handleDeleteConfirmed}
      //    onCancel={() => { setConfirmOpen(false); setTeamToDelete(null); }}
      //  />
      }
    </List>
  );

}


/*
 * Liefert eine iKone abhängig vom Typ des Teams
 */
function TeamIcon({is_female, is_u8})
{
  if (is_female)
  {
    if (is_u8)
    {
      return <GirlIcon />
    }
    else
    {
      return <WomanIcon />
    }
  } 
  else
  {
    if (is_u8)
    {
      return <BoyIcon />
    }
    else
    {
      return <ManIcon />
    }
  }
}


/*
 * besondere Status-Sektionen für solche Teams, die 
 * derzeit nicht mehr berücksichtigt werden sollen oder
 * auf der Warteliste gelandet sind. 
 */
function TeamStatusSection({ label, teams, is_female, is_u8, destination, year, clubLabel, canDelete })
{
  // Menüeintrag verarbeiten - ist er offen oder nicht
  const [menuIsOpen, setMenuIsOpen]  = React.useState(false);
  // möchte der Benutzer etwas ändern, dann wollen wir ihn hier einsteigen lassen
  const navigate = useNavigate();

  // Vorgaben für das komplette Löschen von teams (nur dann, wenn diese zurückgezogen wurden)
  const [deleteTeam] = useDeleteTeamMutation();
  const [confirmDeleteTeamOpen, setConfirmDeleteTeamOpen]  = React.useState(false);
  const [teamToDelete, setTeamToDelete] = React.useState(null);

  const icon = label === 'Warteliste'
    ? <HourglassEmptyIcon />
    : <RemoveCircleOutlinedIcon />;

  //
  // In diesem Fall wurde das Löschen bestätigt und
  // es beginnt an dieser Stelle direkt
  // 
  const handleDeleteConfirmed = async () =>
  {
    // Löschen des Teams anstoßen
    await deleteTeam({year, clubLabel, teamLabel : teamToDelete.label, teamCounter: teamToDelete.counter});
    // danach einfach alles wiedr zurücksetzen
    setConfirmDeleteTeamOpen(false);
    setTeamToDelete(null);
  }

  return (
    <>
      <ListItem variant="level-3" disablePadding>
        <ListItemButton onClick={ () => setMenuIsOpen(!menuIsOpen) }>
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={`${label} (${teams.length})`} />
          {menuIsOpen ? <ExpandLess /> : <ExpandMore /> }
        </ListItemButton>
      </ListItem>
      <Collapse in={menuIsOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {
            teams.map(
              team => (
                <ListItem variant="level-4" key={team.id} disablePadding
                  secondaryAction={
                    canDelete
                    ? <IconButton edge="end" aria-label="delete"                   
                        onClick={ () => 
                          {
                            setTeamToDelete(team);
                            setConfirmDeleteTeamOpen(true);
                          }
                        }
                      > 
                        <DeleteIcon />
                      </IconButton>
                    : undefined
                  }
                >
                  <ListItemButton
                    onClick={  () => navigate(destination + team.label + '/' + team.counter + '/') }
                  >
                    <ListItemIcon>
                      <GroupIcon color="disabled" />
                    </ListItemIcon>
                    <ListItemText 
                      primary={teamName(is_female, is_u8) + ' ' + Arabic2Roman(team.counter) }
                      primaryTypographyProps={{ color: 'text.secondary' }}
                    />
                  </ListItemButton>
                </ListItem>
              )    
            )
          }
        </List>
      </Collapse>
      {
        canDelete && (
          <ConfirmDialog
            open={confirmDeleteTeamOpen}
            title="Team löschen"
            text={teamToDelete ? `${teamName(is_female, is_u8)} ${Arabic2Roman(teamToDelete.counter)} wirklich löschen?` : ''}
            onConfirm={handleDeleteConfirmed}
            onCancel={() => { setConfirmDeleteTeamOpen(false); setTeamToDelete(null); }}
          />
        )
      }
    </>

  );

}


/*
 * Überschrift für einen Eintrag im Team-Menü
 */
function TeamsMenuHeader({year, teams, is_female, is_u8, clubLabel, destination, selectedClub})
{
  // Ein eigener Menüe-Eintrag vorbereiten
  // Hier muss dann später das aktuell selektierte Team hinein...
  const [menuIsOpen, setMenuIsOpen] = React.useState( ); //clubLabel === selectedClub);
  
  // Das Menü ein - oder ausschalten und dabei navigieren, wenn dies denn
  // gewünscht ist
  const toggleMenuIsOpen = () => { 
    // Öffnen oder Schließen des Menüs
    setMenuIsOpen(!menuIsOpen); 
  };

  // Array mit den passenden Teams ermitteln
  let localTeams = teams.filter( 
    team => ( team.clubLabel === clubLabel && team.is_female === is_female && team.is_u8 === is_u8 )

  ).sort( 
    (teamA, teamB) => teamA.counter - teamB.counter 
  );

  // wir zählen hier nur noch die tatsächlich registrierten Teams mit... nicht mehr die
  // jene, die vielleicht zurückgezogen wurden...
  const registeredTeams = localTeams.filter(team => (team.status ?? myConstants.teamModel.status.registered) === myConstants.teamModel.status.registered );
  const waitlistedTeams = localTeams.filter(team => (team.status ?? myConstants.teamModel.status.waitlist) === myConstants.teamModel.status.waitlist );
  const withdrawnTeams = localTeams.filter(team => (team.status ?? myConstants.teamModel.status.withdrawn) === myConstants.teamModel.status.withdrawn );

  const registeredCount = registeredTeams.length;
  const teamCountName = registeredCount > 0 ? `(${registeredCount} Team` + (registeredCount > 1 ? 's':'') + ')' : '' ;

  const team_name = teamName(is_female, is_u8) + ' ' + teamCountName;
  const teamKey   = clubLabel + '_' + teamName;

  // Ausgeben der Liste...
  return(
    <>
      <ListItem variant="level-2" key={teamKey} disablePadding>
        <ListItemButton onClick={toggleMenuIsOpen}>
          <ListItemIcon><TeamIcon is_u8={is_u8} is_female={is_female} /></ListItemIcon>
          <ListItemText primary={team_name} />                
          {menuIsOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </ListItem>  
      <Collapse in={menuIsOpen} timeout="auto" unmountOnExit>
        <TeamItems 
          year={year}
          localTeams={registeredTeams}
          totalTeamCount={localTeams.length}
          is_female={is_female} 
          is_u8={is_u8} 
          clubLabel={clubLabel}
          destination={destination}
          selectedClub={selectedClub}
        />
        {waitlistedTeams.length > 0 && (
          <TeamStatusSection
            label = 'Warteliste'
            teams = {waitlistedTeams}
            is_female={is_female}
            is_u8={is_u8}
            destination={destination}
            year={year}
            clubLabel={clubLabel}
            canDelete={false}
          />
        )}
        {withdrawnTeams.length > 0 && (
          <TeamStatusSection
            label = 'Zurückgezogen'
            teams = {withdrawnTeams}
            is_female={is_female}
            is_u8={is_u8}
            destination={destination}
            year={year}
            clubLabel={clubLabel}
            canDelete={true}
          />
        )}
      </Collapse>        
    </>
  );
}

/*
 * Baut auf der nächsten Ebene die Aufteilung auf unterschiedliche Ebenen auf. 
 * D.h. hier kommt jeweils Überschrift und das Neuanlegen sowie löschen von Teams auf
 */
function TeamsMenu({year, teams, clubLabel, destination, selectedClub})
{

  // die möglichen Altersklassen und die Auspräungen 
  // der entsprechenden Komponenten aus den Teams
  const ageClasses = [
    {is_u8:true, is_female:true},
    {is_u8:false, is_female:true},
    {is_u8:true, is_female:false},
    {is_u8:false, is_female:false},
  ];


  // Lauf über die möglichen Altersklassen
  return(     
    ageClasses.map( 
      ageClass => (
        <React.Fragment key={`${clubLabel}_${ageClass.is_female ? 'w' : 'm'}_${ageClass.is_u8 ? 'u8' : 'u10'}_fragment`}>
          <TeamsMenuHeader 
            year={year}
            teams={teams}
            is_female={ageClass.is_female} 
            is_u8={ageClass.is_u8} 
            clubLabel={clubLabel}
            destination={destination}
            selectedClub={selectedClub}
          />
        </React.Fragment>
      )
    )
  );
}

/*
* Navigation für die Überblicksseite für den Club
*/
function ClubOverview({ year, clubLabel, destination})
{
 
  const navigate = useNavigate();

  return(        
    <ListItem variant="level-2" key={year + clubLabel + 'overview'} disablePadding>
      <ListItemButton onClick={ () => navigate(destination) }>
        <ListItemIcon ><TableChartIcon /></ListItemIcon>
        <ListItemText primary="&Uuml;berblick" />
      </ListItemButton>
    </ListItem>        
  );
}        

/*
 * Erstellt für jeden Club ein eigenes Menü. Dies muss hier in einem eigenen
 * Bereich durchgeführt werden, damit das Öffnen und das Schließen der Menüs
 * auch wirklich durchführbar ist. 
*/
function ClubItem({year, club, teams, location, selectedClub})
{

  // Ein eigener Menüe-Eintrag vorbereiten
  const [menuIsOpen, setMenuIsOpen] = React.useState(club.label === selectedClub);
  
  // Das Menü ein - oder ausschalten und dabei navigieren, wenn dies denn
  // gewünscht ist
  const toggleMenuIsOpen = () => 
  { 
    // Öffnen oder Schließen des Menüs
    setMenuIsOpen(!menuIsOpen); 
  };

  // Vorbereiten des Ziels
  const destinationURL = location + '/' + club.label + '/';


  // Eintrag für einen neuen Club einfügen
  return(
    <React.Fragment key={year + club.label + '_fragment'}>
      <ListItem variant="level-1" key={year + club.label} disablePadding>
        <ListItemButton onClick={toggleMenuIsOpen} >
          <ListItemIcon ><GroupsIcon /></ListItemIcon>
          <ListItemText primary={club.name} />
          {menuIsOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </ListItem>
      <Collapse  in={menuIsOpen} timeout="auto" unmountOnExit>
        <List>
          <ClubOverview year={year} clubLabel={club.label} destination={destinationURL} />        
          <TeamsMenu year={year} teams={teams} clubLabel={club.label} destination={destinationURL} selectedClub={selectedClub}/>                  
        </List>
      </Collapse>
    </React.Fragment>
  );
}


/*
* Ermittelt die Vereine, die interessiert, aber noch nicht angemeldet sind. 
*/
function SpecialStateClubMenu({selectedYear, selectedClub, user, registrations, teams, pathURL, status })
{
  // Ein eigener Menüe-Eintrag vorbereiten
  const [menuIsOpen, setMenuIsOpen] = React.useState(    
    (
      selectedClub && registrations.find( 
        registration => registration.club.label === selectedClub 
      )?.status === status 
    )
  );
  
  // Das Menü ein - oder ausschalten und dabei navigieren, wenn dies denn
  // gewünscht ist
  const toggleMenuIsOpen = () => 
  { 
    // Öffnen oder Schließen des Menüs
    setMenuIsOpen(!menuIsOpen); 
  };

  let isInterested = (status === myConstants.clubModel.status.interested); 
  let statusName = (status === myConstants.clubModel.status.interested)?'Interessenten':'Absagen';

  // Eintrag für einen neuen Club einfügen
  return(
    <React.Fragment key={statusName + "_fragment"}>
      <ListItem key={statusName} disablePadding>
        <ListItemButton onClick={toggleMenuIsOpen} >
          <ListItemIcon >{isInterested?<InterestsRoundedIcon />:<HighlightOffRoundedIcon />}</ListItemIcon>
          <ListItemText primary={statusName} />
          {menuIsOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </ListItem>
      <Collapse  in={menuIsOpen} timeout="auto" unmountOnExit>
        <List>
          {
            registrations?.filter(
              registration => registration.status === status
            ).map(
              registration => (
                <ClubItem 
                  key={selectedYear + registration.club.label + "_clubItem"}
                  year={selectedYear} 
                  club={registration.club} 
                  teams={teams} 
                  location={pathURL} 
                  selectedClub={selectedClub}
                />
              )
            )          
          }
        </List>
      </Collapse>
    </React.Fragment>
  );
}


/*
* Zeigt das ClubMenu an, welches die einzelnen Clubs die der Benutzer hier
* bearbeiten kann, in einer Übersicht anzeigt. 
*/
export function ClubMenu({selectedYear, selectedClub, user, registrations, pathURL })
{
  const navigate = useNavigate();

  // Einlesen des aktuellen Teams, sofern dies noch nicht erfolgt ist - wir lesen hierbei
  // immer alle hier anzuzeigenden Teams hinzu. Sollten wir also nur einen Club haben, dann
  // lesen wir nur diesen - sollten wir mehrere haben, dann lesen wir alle...  
  const {data:teams, isLoading:teamsIsLoading} = useFetchTeamsQuery(
    { 
      year: selectedYear,
      clubLabel: (user.priviledged)?'':(registrations?.length > 0 )?registrations[0].club.label:'',
    }
  );

  if (teamsIsLoading)
  {
    return (
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    );
  }
  else 
  {
    return(
      <List>
        { 
          // Hier wollen wir nur die vollständig angemeldeten Vereine sehen und filtern daher darauf
          registrations?.filter(
            registration => registration.status === myConstants.clubModel.status.registered
          ).map(
            registration => (
              <ClubItem 
                key={registration.club.label + "_clubItemRegistrations"}
                year={selectedYear} 
                club={registration.club} 
                teams={teams} 
                location={pathURL} 
                selectedClub={selectedClub}
              />
            )
          )
        } 
        {
          user.priviledged
          ? <>
              <ListItem variant="level-1" color="secondary" key="AddClub" disablePadding>
                <ListItemButton onClick={ () => navigate( pathURL + '/' + myConstants.endpoints.actions.club.add ) } >
                  <ListItemIcon ><AddCircleOutlineIcon /></ListItemIcon>
                  <ListItemText primary="Verein anmelden" />
                </ListItemButton>
              </ListItem>  

              <Divider />

              <SpecialStateClubMenu 
                selectedYear={selectedYear} 
                selectedClub={selectedClub} 
                teams={teams} 
                user={user} 
                registrations={registrations} 
                pathURL={pathURL} 
                status={myConstants.clubModel.status.interested}
              />

              <SpecialStateClubMenu 
                selectedYear={selectedYear} 
                selectedClub={selectedClub} 
                teams={teams} 
                user={user} 
                registrations={registrations} 
                pathURL={pathURL} 
                status={myConstants.clubModel.status.cancelled}
              />
          
            </>
          :   ''
        }
      </List>
    );
  }
}



export default function SideMenu ({isSideMenuOpen, onSideMenuToggle}) 
{
  const params = useParams(); 
  // Aktuelles Jahr aus dem aktuellen URL lesen
  const selectedYear = parseInt(params.year);
  // Sofern vorhanden, ermitteln wir das Club-Label aus dem URL
  const selectedClub   = params.clubLabel;
  // Einlesen der angemeldeten Vereine in dem aktuell betrachteten Turnierjahr
  const {data:registrations, isLoading:registrationsIsLoading} = useFetchClubsRegistrationsQuery(selectedYear);
  // Zugriff auf den aktuellen Benutzer vornehmen
  const {data:user, isLoading:userIsLoading} = useGetProfileQuery();
  // aktuellen Ort ermitteln (brauchen wir, damit wir die anderen
  // Verknüpfungen aufbauen können)
  //const {pathname:pathURL} = useLocation();  
  const pathURL = '/' + selectedYear;
  
  const navigate = useNavigate();

  if (registrationsIsLoading||userIsLoading)
  {
    return (
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    );
  }
  else
  {
    return (
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="persistent"
        anchor="left"        
        open={isSideMenuOpen}
      >
        <Toolbar />
        <DrawerHeader>
          <IconButton onClick={onSideMenuToggle}><ChevronLeftIcon /></IconButton>
        </DrawerHeader>
        <Divider />
        <ClubMenu selectedYear={selectedYear} selectedClub={selectedClub} user={user} registrations={registrations} pathURL={pathURL} />
        <Divider />        
        {
          user.priviledged
          ? <>
              <Divider />
              <List>
                <ListItem variant="level-1" key="Administration" disablePadding>
                  <ListItemButton onClick={ () => navigate( pathURL + '/admin') }>
                    <ListItemIcon><AdminPanelSettingsIcon /></ListItemIcon>
                    <ListItemText primary="Administration" />
                  </ListItemButton>
                </ListItem>                            
              </List>
            </>
          : ""
        }
      </Drawer>
    );
  }
}